import React, { useState, useEffect } from "react";
import { sha512 } from "js-sha512";
import eyeIcon from "../../Assets/Images/ojoNMF.png";
import eyeSlashIcon from "../../Assets/Images/cerrar-ojoNMF.png";
import "./EditarPerfilComponent.css";
import { Notification } from "../NotificationLoginComponent";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from 'react-icons/fa';
import { getActiveProfileToken } from "../../utils/profileStorage";

export const EditarPerfilComponent = ({ user, I18n }) => {
  const navigate = useNavigate();

  // Notificación global
  const [notificationMessage, setNotificationMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [isErrorNoti, setIsErrorNoti] = useState(false);

  // Datos de formulario, incluyendo DNI
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    telephone: "",
    email: "",
    rewards: "",
    partners: "",
    birthday: "",
    dni: "",        // ← nuevo campo para guardar el DNI
  });

  // Datos de contraseña
  const [passwordData, setPasswordData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  // Estados para mostrar/ocultar contraseña
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Control de si el usuario ya cambió la contraseña
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  // Contraseña default generada
  const [defaultPassword, setDefaultPassword] = useState("");

  // Hash almacenado en el servidor
  const [storedPasswordHash, setStoredPasswordHash] = useState("");

  // Errores específicos en los campos (para estilo y mensajes)
  const [errors, setErrors] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  /**
   * Genera la contraseña por defecto: 3 letras del primer apellido + día, mes y últimos 2 dígitos del año
   * Ej: "Iglesias" + "14/10/2004" => "igl141004"
   */
  const generateDefaultPassword = (surname, birthday) => {
    if (!surname || !birthday) return "";
    const birthDate = new Date(birthday);
    const day = String(birthDate.getDate()).padStart(2, "0");
    const month = String(birthDate.getMonth() + 1).padStart(2, "0");
    const year = String(birthDate.getFullYear()).slice(-2);
    return `${surname.split(" ")[0].slice(0, 3).toLowerCase()}${day}${month}${year}`;
  };

  

  /**
   * Convierte la fecha del usuario en formato YYYY-MM-DD para el input "date"
   */
  const formatBirthday = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
const safeArray = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === "string") {
    try {
      const parsed = JSON.parse(v);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      // por si viene "a,b,c"
      return v.trim() ? v.split(",").map(x => x.trim()).filter(Boolean) : [];
    }
  }
  return [];
};

  /**
   * Al montar el componente, cargamos datos del usuario:
   * - Generamos la contraseña por defecto
   * - Rellenamos formData con los valores de user (incluyendo DNI)
   * - Comparamos hash para ver si la contraseña es la default
   */
  useEffect(() => {
    if (user) {
      // 1) Generar la contraseña por defecto
      const defaultPass = generateDefaultPassword(user.surname, user.birthday);
      setDefaultPassword(defaultPass);

      // 2) Llenar formData con los datos del usuario
setFormData({
  name: user.name || "",
  surname: user.surname || "",
  telephone: user.telephone || "",
  email: user.email || "",
  rewards: safeArray(user.rewards).join(", "),
  partners: safeArray(user.partners).join(", "),
  birthday: formatBirthday(user.birthday),
  dni: user.dni || "",
});


      // 3) Reiniciar los campos de contraseña en el formulario
      setPasswordData({
        newPassword: "",
        confirmPassword: "",
      });

      // 4) Guardar el hash que nos trajo el usuario
      setStoredPasswordHash(user.password);

      // 5) Verificar si la contraseña en la DB coincide con la default
      if (sha512(defaultPass) === user.password) {
        // Si coincide, la contraseña actual es la default: pre-poblar inputs
        setIsPasswordChanged(false);
        setPasswordData({
          newPassword: defaultPass,
          confirmPassword: defaultPass,
        });
      } else {
        // Si no coincide, significa que el usuario ya cambió la contraseña
        setIsPasswordChanged(true);
      }
    }
  }, [user]);

  /**
   * Manejo de cambios en campos de formulario (incluye DNI)
   */
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /**
   * Manejo de cambios en campos de contraseña
   */
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    // Limpiar errores relacionados al campo que se está tecleando
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  /**
   * Toggle para ver/ocultar la contraseña (campo "newPassword")
   */
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  /**
   * Toggle para ver/ocultar la contraseña (campo "confirmPassword")
   */
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  /**
   * Al enviar el formulario:
   * - Validamos que, si el usuario introduce nueva contraseña, coincidan ambos campos.
   * - Preparamos el array de partners y rewards.
   * - Decidimos qué hash de contraseña enviar (default o nuevo).
   * - Construimos el payload incluyendo:
   *     • dni: formData.dni
   *     • username: formData.dni  ← para que siempre coincida con el DNI
   * - Enviamos el fetch al endpoint de actualización.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1) Reiniciar errores de validación
    setErrors({ newPassword: "", confirmPassword: "" });

    // 2) Validar que, si teclean contraseña, new y confirm coincidan
    if (passwordData.newPassword || passwordData.confirmPassword) {
      if (passwordData.newPassword !== passwordData.confirmPassword) {
        setErrors({
          newPassword: "Las contraseñas no coinciden",
          confirmPassword: "Las contraseñas no coinciden",
        });
        return;
      }
    }

    // 3) Formatear arrays de partners y rewards (vienen como strings separados por comas)
    const formattedPartners = formData.partners
      ? formData.partners.split(",").map((p) => p.trim())
      : [];
    const formattedRewards = formData.rewards
      ? formData.rewards.split(",").map((r) => r.trim())
      : [];

    // 4) Decidir qué hash de contraseña enviar:
    //    - Si el usuario no cambióla contraseña y lo que hay almacenado es el default, enviamos el default.
    //    - Si escribieron algo distinto, enviamos la SHA512 de la nueva.
    const isUsingDefault =
      passwordData.newPassword === defaultPassword &&
      sha512(defaultPassword) === storedPasswordHash;
    const finalPasswordHash = isUsingDefault
      ? sha512(defaultPassword)
      : sha512(passwordData.newPassword);

    // 5) Construir el objeto que se enviará al servidor
    const payload = {
      Id: user.Id,
      name: formData.name,
      surname: formData.surname,
      dni: formData.dni,             // ← enviamos el DNI que esté en formData
      username: formData.dni,        // ← obligamos a que username siempre sea igual a DNI
      partners: JSON.stringify(formattedPartners),
      telephone: formData.telephone ? parseInt(formData.telephone) : null,
      email: formData.email,
      rewards: JSON.stringify(formattedRewards),
      birthday: formData.birthday,
      password: finalPasswordHash,
    };

    try {
      const response = await fetch(
        "https://api.fallaplazarodrigo.es:999/Users/UpdateOwnAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: getActiveProfileToken(),
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setNotificationMessage(I18n.ProfileUpdated);
        setIsErrorNoti(false);
      } else {
        setNotificationMessage(data.message || I18n.ErrorUpdatingProfile);
        setIsErrorNoti(true);
      }
      setShowNotification(true);

      // Redirigir a /perfil después de que se muestre la notificación
      setTimeout(() => {
        window.location.href = "/perfil";
      }, 3000);
    } catch (error) {
      console.error("Error inesperado:", error);
      setNotificationMessage(I18n.UnexpectedError);
      setIsErrorNoti(true);
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 5000);
    }
  };

  return (
    <div className="edit-user">
      {showNotification && (
        <Notification
          message={notificationMessage}
          type={isErrorNoti ? "error" : "success"}
          show={showNotification}
        />
      )}
      <h1 className="titulo-page">Actualizar Perfil</h1>
      <div className="back-link-container">
      <button className="back-button" onClick={() => navigate('/perfil')}>
        <FaArrowLeft className="back-icon" /> Volver
      </button>
      </div>

      <form className="edit-profile-form" onSubmit={handleSubmit}>
        {/* NOMBRE */}
        <label>
          {I18n.Name}:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
        </label>

        {/* APELLIDOS */}
        <label>
          {I18n.Surname}:
          <input
            type="text"
            name="surname"
            value={formData.surname}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
        </label>

        {/* DNI (editable) */}
        <label>
          DNI:
          <input
            type="text"
            name="dni"
            value={formData.dni}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
          <small>El campo “username” se guardará automáticamente igual que el DNI.</small>
        </label>

        {/* TELÉFONO */}
        <label>
          {I18n.Phone}:
          <input
            type="text"
            name="telephone"
            value={formData.telephone}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
        </label>

        {/* EMAIL */}
        <label>
          {I18n.Email}:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
        </label>

        {/* PARTNERS */}
        <label>
          {I18n.Partners}:
          <input
            type="text"
            name="partners"
            value={formData.partners}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
        </label>

        {/* REWARDS */}
        <label>
          {I18n.Rewards}:
          <input
            type="text"
            name="rewards"
            value={formData.rewards}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
          <small>{I18n.RewardsInstructions}</small>
        </label>

        {/* FECHA DE NACIMIENTO */}
        <label>
          {I18n.Birthdate}:
          <input
            type="date"
            name="birthday"
            value={formData.birthday}
            onChange={handleFormChange}
            className="edit-profile-input"
          />
        </label>

        {/* TÍTULO SECCIÓN CONTRASEÑA */}
        <h4 className="subtitulo">Configura Contraseña</h4>

        {/* NUEVA CONTRASEÑA */}
        <label>
          {I18n.NewPassword}:
          <div className="password-input">
            <input
              type={showNewPassword ? "text" : "password"}
              name="newPassword"
              value={passwordData.newPassword}
              onChange={handlePasswordChange}
              className={`edit-profile-input ${
                errors.newPassword ? "error" : ""
              }`}
            />
            <img
              src={showNewPassword ? eyeIcon : eyeSlashIcon}
              alt="Toggle Password Visibility"
              className="password-icon"
              onClick={toggleNewPasswordVisibility}
            />
          </div>
          {errors.newPassword && (
            <p className="error-message">{errors.newPassword}</p>
          )}
        </label>

        {/* CONFIRMAR CONTRASEÑA */}
        <label>
          {I18n.ConfirmPassword}:
          <div className="password-input">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              value={passwordData.confirmPassword}
              onChange={handlePasswordChange}
              className={`edit-profile-input ${
                errors.confirmPassword ? "error" : ""
              }`}
            />
            <img
              src={showConfirmPassword ? eyeIcon : eyeSlashIcon}
              alt="Toggle Password Visibility"
              className="password-icon"
              onClick={toggleConfirmPasswordVisibility}
            />
          </div>
          {errors.confirmPassword && (
            <p className="error-message">{errors.confirmPassword}</p>
          )}
        </label>

        {/* BOTÓN ACTUALIZAR PERFIL */}
        <button type="submit" className="edit-profile-button">
          {I18n.UpdateProfile}
        </button>
      </form>
    </div>
  );
};
